var module = angular.module('octopusApp.projects');
import React from 'react';
import StepTemplateLogo from 'step_template_logo';
import showdown from 'showdown';
import xss from 'xss';
import AceEditor from 'ace_editor';
import TemplateSummary from 'template_summary';
import TemplateParameters from 'template_parameters';


var markdownConverter = new showdown.Converter({
    simplifiedAutoLink: true,
    literalMidWordUnderscores:true
});

function Info(props){
    return <div className="row">
                <div className="col-md-12">
                    <div className="alert alert-info margin" role="alert">{props.children}</div>
                </div>
            </div>
}

function Warning(props){
    return <div className="row">
        <div className="col-md-12">
            <div className="alert alert-warning margin" role="alert">{props.children}</div>
        </div>
    </div>
}

function TemplateHelperLinks(){
    return <div>
        <span className="pull-right">Provided under the <a href="http://g.octopushq.com/CommunityLibraryLicense" target="_blank">Apache License version 2.0.</a></span>
    </div>;
};

var LibraryStepTemplateDetails = React.createClass({
    propTypes: {
        template: React.PropTypes.object.isRequired,
        onInstall: React.PropTypes.func.isRequired,
        installButtonName: React.PropTypes.string,
        onUpdate: React.PropTypes.func.isRequired,
        updateButtonName: React.PropTypes.string,
        onCancel: React.PropTypes.func.isRequired,
        cancelButtonName: React.PropTypes.string,
        currentVersion: React.PropTypes.number,
        resolveLink: React.PropTypes.func.isRequired
    },
    getInitialState: function () {
        return {tab: 'Parameters'};
    },
    getSelectedTabCssClassName: function (tabName) {
        return tabName === this.state.tab ? 'active' : '';
    },
    selectTab: function (e) {
        this.setState({
            tab: e.target.text
        });
    },
    render() {

        var inputTabClasses = 'tab-pane ' + this.getSelectedTabCssClassName('Parameters');
        var sourceCodeTabClasses = 'tab-pane ' + this.getSelectedTabCssClassName('Source code');

        var templateDescriptionHtml = {__html: xss(markdownConverter.makeHtml(this.props.template.Description || ''))};

        var templateParameters = [];
        if (this.props.template.Parameters) {
            templateParameters = this.props.template.Parameters.map(p => {
                var param = p;
                param.HelpHtml = {__html: xss(markdownConverter.makeHtml(p.HelpText || ''))};
                return param;
            });
        }

        var scriptSyntax = 'powershell';
        var scriptSourceCode = 'Not available';
        if (this.props.template.Properties) {
            var tmpScriptSyntax = this.props.template.Properties['Octopus.Action.Script.Syntax'] || scriptSyntax;
            scriptSyntax = tmpScriptSyntax.toLowerCase();
            scriptSourceCode = this.props.template.Properties['Octopus.Action.Script.ScriptBody'] || scriptSourceCode;
            if (this.props.template.Type !== 'Octopus.Script') {
                scriptSourceCode = 'Source code is not available for this step template because it is not a script template.';
            }
        }

        var isUpdateAvailable = this.props.currentVersion !== undefined && this.props.currentVersion  < this.props.template.Version;

        return (<div className="step-templates-details">

            {!isUpdateAvailable ? <Info>This is a community contributed step that will be installed into your <a className="alert-link" href="#/library/steptemplates">Step templates</a> library. Read our <a className="alert-link" href="http://g.octopushq.com/CommunityContributedStepTemplates" target="_blank">community step documentation</a> for more information.</Info> : null}
            {isUpdateAvailable ? <Warning>Update available. Please review <a className="alert-link" href={this.props.template.HistoryUrl} target="_blank">the history of this template</a> to find out what's changed between currently installed version <span className="template-version">{this.props.currentVersion}</span> and new version <span className="template-version">{this.props.template.Version}</span>.</Warning> : null}

            <div>
                <div className="template-logo-container">
                    <StepTemplateLogo size="large" class="template-logo" url={this.props.template.Links.Logo} resolveLink={this.props.resolveLink} />
                </div>

                <div className="template-details-container">
                    <div className="row margin-5">
                        <div className="col-md-12 no-padding-hr">

                            <TemplateSummary name={this.props.template.Name} descriptionHtml={templateDescriptionHtml} author={this.props.template.Author}
                                             version={this.props.template.Version} websiteUrl={this.props.template.Website} isUpdateAvailable={isUpdateAvailable}
                                             onInstall={this.props.onInstall} installButtonName={this.props.installButtonName}
                                             onUpdate={this.props.onUpdate} updateButtonName={this.props.updateButtonName}
                                             onCancel={this.props.onCancel} cancelButtonName={this.props.cancelButtonName} />

                            {/* Tab Headers */}
                            <div>
                                <ul className="nav nav-tabs nav-tabs-simple">
                                    <li className={this.getSelectedTabCssClassName('Parameters')}><a
                                        className="clickable" onClick={this.selectTab}>Parameters</a></li>
                                    <li className={this.getSelectedTabCssClassName('Source code')}><a
                                        className="clickable" onClick={this.selectTab}>Source code</a></li>
                                </ul>
                            </div>
                            {/* Tab Content */}
                            <div className="tabbable tabs-top">
                                <div className="tab-content pills-content">
                                    <div className={inputTabClasses}>
                                        {templateParameters != null && templateParameters.length > 0
                                            ? <TemplateParameters templateParameters={templateParameters}/>
                                            : <span>This template has no parameters.</span>
                                        }
                                    </div>
                                    <div className={sourceCodeTabClasses}>
                                        <AceEditor mode={scriptSyntax} code={scriptSourceCode}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr/>

            <TemplateHelperLinks />

        </div>);
    }
});

module.directive('libraryStepTemplateDetails', function (reactDirective) {
    return reactDirective(LibraryStepTemplateDetails);
});


// WEBPACK FOOTER //
// ./app/areas/library/steps/views/community_step_template_details.jsx